import { atom } from 'jotai';

export const startedAutoUpdateVersionAtom = atom<string | undefined>(undefined);
